module.exports = "/_next/static/images/5d28a1f70f49bf5621ebdee1f9615195-man-looking-up-smiling-lg@2x.jpg.webp";